//Created by wangshuyi on 07/03/2018.

'use strict';
let Common = {
  config: {
    test: '123',
  },
  test() {
    alert('test');
  },
};

export default Common
